module.exports = {"env":"local","api":"localhost"}